import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { Warning } from '@mui/icons-material'

function ResetAllDialog({ open, setOpen }: { open: boolean; setOpen: any }) {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>{'Reset All Settings?'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          All saved preference and stored data will be erased from this device
          upon next page refresh. This cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="warning"
          variant={'outlined'}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            localStorage.clear()
            setOpen(false)
          }}
          startIcon={<Warning />}
          color="error"
          autoFocus
          variant={'outlined'}
        >
          Proceed Resetting
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ResetAllDialog
